import Vue from 'vue';
import i18n from '@/languages';

Vue.filter('uppercase', function (value) {
    return value.toString().toUpperCase();
});


Vue.filter('formatting', function (value, type, params) {
    let result;
    if(value){
        switch (type) {
            case 'percentage':
                result = value + '%';
                break
            case 'currency':
                result = value + ' ' + (params + "").replace(/&#\d+;/gm, function (s) {
                    return String.fromCharCode(s.match(/\d+/gm)[0]);
                })
                break
            case 'boolean':
                result = value === '0' ? i18n.t('LBL_NO') : i18n.t('LBL_YES')
                break
            default:
                result = value
        }
    }else{
        result ='-'
    }

    return result
});

